import React, { useState } from "react";
import { useDialog } from "../Dialogs/DialogProvider";
import { DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Allergen } from "../../store/articles/models/Allergen";

function CreateAllergenView(props) {
  const [, closeDialog] = useDialog();
  const [allergen, setAllergen] = useState(new Allergen(null, null, "", null, props.merchantId, null));
  return (
    <>
      <DialogTitle>New label</DialogTitle>
      <DialogContent>
        <TextField
          variant={"outlined"}
          value={allergen.name}
          onChange={(e) => {
            let newAllergen = Object.assign(new Allergen(), allergen);
            newAllergen.name = e.target.value;
            setAllergen(newAllergen);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant={"outlined"}
          color={"primary"}
          onClick={() => {
            closeDialog();
          }}
        >
          Cancel
        </Button>
        <Button
          variant={"outlined"}
          color={"primary"}
          onClick={() => {
            props.onSave(allergen);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
}

export default CreateAllergenView;
